import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import StudentLogin from '../Auth/Student/StudentLogin';
import ConfirmRegistration from '../Auth/Student/ConfirmRegistration';
import Otp from '../Auth/Student/Otp';
import SetPassword from '../Auth/Student/SetPassword';
import ForgetPassword from '../Auth/Student/StudentForgetPassword';

import StudentProfile from '../pages/student/studentProfile.page';
import StudentCourses from '../pages/student/studentCourses.page';
import StudentExams from '../pages/student/studentExams.page';
import StudentSubjects from '../pages/student/StudentSubjects.page';
import StudentChapters from '../pages/student/StudentChapters.page';
import StudentLectures from '../pages/student/StudentLectures.page';
import StudentQuestionSolve from '../pages/student/StudentQuestionSolve.page';
import QAForumList from '../pages/student/QAForumList.page';
import StudentVideos from '../pages/student/StudentVideos.page';
import StudentNotes from '../pages/student/StudentNotes.page';
import StudentLiveExam from '../pages/student/StudentLiveExams.page';
import QuickPracticeExam from '../pages/student/QuickPracticeExam.page';
import QuestionWorldPage from '../pages/student/question_world/page';
import QuestionWorldExam from '../pages/student/question_world/QuickPracticeExam.page';
import StudentResult from '../pages/student/StudentResult.page';
import StudentScoreboard from '../pages/student/StudentScoreboard.page';
import { getStudentProfile } from '../../stateManager/reducers/studentAuthSlice'
import CommentList from '../pages/student/QuestionDetails.page';
import MYQA from '../pages/student/MyQA.page';
import BookmarkQuestion from '../pages/student/bookmark_questions/BookmarkQuestion';

const StudentRoutes = () => {
	const dispatch = useDispatch();
	const isLoggedIn = !!localStorage.getItem('student');

	useEffect(() => {
		if (isLoggedIn) {
			dispatch(getStudentProfile());
		}
	}, [isLoggedIn, dispatch]);

	return (
		<Router>
			<Switch>
				{/* Public Routes with redirect if already logged in */}
				<Route path='/login'>{isLoggedIn ? <Redirect to='/' /> : <StudentLogin />}</Route>
				<Route path='/register'>{isLoggedIn ? <Redirect to='/' /> : <ConfirmRegistration />}</Route>
				<Route path='/otp'>{isLoggedIn ? <Redirect to='/' /> : <Otp />}</Route>
				<Route path='/setpassword'>{isLoggedIn ? <Redirect to='/' /> : <SetPassword />}</Route>
				<Route path='/forget-password'>{isLoggedIn ? <Redirect to='/' /> : <ForgetPassword />}</Route>

				{/* Private Routes */}
				{isLoggedIn ? (
					<>
						<Route exact path='/' component={StudentCourses} />
						<Route path='/courses' component={StudentCourses} />
						<Route path='/exams' component={StudentExams} />
						<Route path='/subjects/:courseId' component={StudentSubjects} />
						<Route path='/qa-forum-list/:id' component={QAForumList} />
						<Route path='/student-profile' component={StudentProfile} />
						<Route path='/videos/:chapterId/:type' component={StudentVideos} />
						<Route path='/notes/:chapterId/:type' component={StudentNotes} />
						<Route path='/chapters/:subjectId' component={StudentChapters} />
						<Route path='/lectures/:subjectId' component={StudentLectures} />
						<Route path='/question-details/:id' component={CommentList} />
						<Route path='/my-qa' component={MYQA} />
						<Route path='/bookmark-questions' component={BookmarkQuestion} />
						<Route path='/question-solve/:subjectId' component={StudentQuestionSolve} />
						<Route path='/live-exam/:examId/:groupId' component={StudentLiveExam} />
						<Route path='/quick-practice-exam/:examId/:groupId' component={QuickPracticeExam} />
						<Route exact path='/question-world' component={QuestionWorldPage} />
						<Route path='/question-world/exam/:examId/:groupId' component={QuestionWorldExam} />
						<Route path='/result/:examId/:groupId' component={StudentResult} />
						<Route path='/scoreboard' component={StudentScoreboard} />
					</>
				) : (
					<Route path='*'>
						<Redirect to='/login' />
					</Route>
				)}
			</Switch>
		</Router>
	);
};

export default StudentRoutes;
